import { Card, Caption1, Title3 } from '@fluentui/react-components';
import type { DashboardKpi } from '../../../hooks/useDashboard';

export const KpiWidget = ({ item }: { item: DashboardKpi }) => (
  <Card>
    <Caption1>{item.label}</Caption1>
    <Title3>{item.value}</Title3>
    <span>{item.helperText}</span>
  </Card>
);
